// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Woj8","title":"Images90_title__23OLY","images":"Images90_images__2ZMy3"};